import React from 'react';
import { Slot } from 'react-plugin';
export function ControlSlot({ slotProps }) {
    return (React.createElement(Slot, { name: `control-${slotProps.control.type}`, slotProps: slotProps }));
}
